/**
 *
 * Priority3Badge
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import { COLORS } from '../../../../theme';
import Badge from '..';

const StyledBadge = styled(Badge)`
  &.MuiChip-root {
    color: ${COLORS.rustDark};
    background: ${COLORS.rustLight};
    border-color: ${COLORS.rust};
  }

  && .MuiSvgIcon-root {
    path {
      fill: ${COLORS.rust};
    }
  }
`;

function Priority3Badge(props) {
  return <StyledBadge label="3rd Priority" {...props} />;
}

export default memo(Priority3Badge);
